import { TasticConfiguration } from '@frontastic/extension-types';
import { DataSources } from 'frontastic/lib/types';

export const injectDataSources = (
  block: TasticConfiguration,
  dataSources: DataSources
) => {
  const result = Object.entries(block).reduce((acc, [key, value]) => {
    if (key === 'dataSourceId') {
      return {
        ...acc,
        [key]: value,
        dataSource: dataSources[value],
      };
    }

    const isObject =
      value !== null && typeof value === 'object' && !Array.isArray(value);

    if (isObject) {
      return {
        ...acc,
        [key]: injectDataSources(value, dataSources),
      };
    }

    return {
      ...acc,
      [key]: value,
    };
  }, {}) as TasticConfiguration & { dataSource?: DataSources };

  return result;
};
